import { useMemo } from "react";

import { colors } from "@dotnet/telematics-design-system";

import { BANNER_LEVEL_LABELS, BannerLevelOption } from "shared";

const useBannerLevels = (initialLabel: BANNER_LEVEL_LABELS) => {
    const { blue100, blue400, orange200, orange400 } = colors;

    const LEVEL_OPTIONS: BannerLevelOption[] = useMemo(
        () => [
            {
                label: BANNER_LEVEL_LABELS.Warning,
                background: orange200,
                border: orange400
            },
            {
                label: BANNER_LEVEL_LABELS.Info,
                background: blue100,
                border: blue400
            }
        ],
        [blue100, blue400, orange200, orange400]
    );

    const activeLevelOption = useMemo(
        () =>
            LEVEL_OPTIONS.find(
                levelOption => levelOption.label === initialLabel
            ) ?? LEVEL_OPTIONS[0],
        [LEVEL_OPTIONS, initialLabel]
    );

    return { LEVEL_OPTIONS, activeLevelOption };
};

export { useBannerLevels };
